import styled from 'styled-components';

const NewsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 40px;
    width: 100%;
`;

export default NewsContainer;
